import React, { ReactNode } from 'react';

interface WrapperProps {
  className?: string;
  children: ReactNode;
}

const Wrapper = ({ className, children }: WrapperProps): JSX.Element => (
  <aside
    className={`top-sticky-banner min-h-56 flex w-full flex-row flex-wrap items-center justify-center px-16 py-8 ${className}`}
  >
    {children}
  </aside>
);

export default Wrapper;
